import { HeroMapType } from '@op/pages/Hero/utils';
import { DownloadConfigInfoType } from '../types';
import { LocaleType } from '@op/types/common';
import { getTierTopicList } from '@op/services';
import { dealwithNIKKEList } from '@op/pages/NIKKE/utils';
import { sortable } from 'tea-component/lib/table/addons';
import { nikkeTimeLineTypeMap } from '@op/pages/NIKKE/constants';
import { sentimentNumber } from '../renderHelper';
import { formatFilterTime } from '../renderHelper/time';

function getHeroNameFunc(heroMap: HeroMapType, language: LocaleType) {
  return (item: any, key: string) => {
    const value = item[key];

    return heroMap[value]?.[language];
  };
}

function dealwithQoq(item: any, key: string) {
  const value = item[key];

  return value / 100;
}
export const NikkeTable: DownloadConfigInfoType = {
  columns: ({ auxiliaryParams }) => {
    const { heroInfoMap } = auxiliaryParams;

    return [
      {
        key: 'topic',
        header: 'Nikkes(cn)',
        renderHelper: [getHeroNameFunc(heroInfoMap, 'zh-CN')],
      },
      {
        key: 'topic',
        header: 'Nikkes(en)',
        renderHelper: [getHeroNameFunc(heroInfoMap, 'en-US')],
      },
      {
        key: 'mentions',
        header: 'Mentions',
      },
      {
        key: 'mentions_qoq',
        header: 'Mentions Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
      {
        key: 'mentions_ratio',
        header: 'Mentions%',
        numFmt: '0.00%',
      },
      {
        key: 'mentions_ratio_qoq',
        header: 'Mentions% Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
      {
        key: 'positive_mentions_ratio',
        header: 'Positive%',
        numFmt: '0.00%',
      },
      {
        key: 'positive_mentions_ratio_qoq',
        header: 'Positive% Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
      {
        key: 'negative_mentions_ratio',
        header: 'Negative%',
        numFmt: '0.00%',
      },
      {
        key: 'negative_mentions_ratio_qoq',
        header: 'Negative% Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
      {
        key: 'neutral_mentions_ratio',
        header: 'Neutral%',
        numFmt: '0.00%',
      },
      {
        key: 'neutral_mentions_ratio_qoq',
        header: 'Neutral% Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
      {
        key: 'engagement',
        header: 'Engagement',
      },
      {
        key: 'engagement_qoq',
        header: 'Engagement Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
      {
        key: 'engagement_ratio',
        header: 'Engagement%',
        numFmt: '0.00%',
      },
      {
        key: 'engagement_ratio_qoq',
        header: 'Engagement% Change%',
        renderHelper: [dealwithQoq],
        numFmt: '0.00%',
      },
    ];
  },
  type: 'excel',
  downloadFunc: (filter) =>
    getTierTopicList({ ...filter, page: 1, page_size: 1000 }),
  dealWithDataFunc: ({ data, filter, auxiliaryParams }) => {
    const { sort } = auxiliaryParams;
    const { tableData } = dealwithNIKKEList(data, filter);
    try {
      tableData.sort(sortable.comparer([sort]));
    } catch (error) {}
    return tableData;
  },
};

export const NikkeTimeline: DownloadConfigInfoType = {
  columns: ({ filter, auxiliaryParams }) => {
    const { heroInfoMap, header: tableHeader, indicators } = auxiliaryParams;

    const isRatio = [
      'mentions_ratio',
      'negative_mentions',
      'positive_mentions',
      'engagement_ratio',
    ].includes(indicators);

    const tableColumns: any = [
      {
        key: 'time',
        header: 'Time',
        fixed: 'left',
        renderHelper: [formatFilterTime(filter)],
      },
    ];

    let item = nikkeTimeLineTypeMap[indicators];
    const headerText = item.downloadText;

    if (headerText) {
      tableColumns.push({
        key: 'total',
        align: 'right',
        header: headerText,
      });
    }

    const getHeroName = getHeroNameFunc(heroInfoMap, 'zh-CN');
    tableHeader.forEach((title: any) => {
      let column: any = {
        key: title,
        align: 'right',
        header: `${getHeroName({ title }, 'title')}(${title})`,
      };
      if (isRatio) {
        column['numFmt'] = '0.00%';
      }
      if (indicators === 'sentiment') {
        column.renderHelper = [sentimentNumber];
      }
      tableColumns.push(column);
    });

    return tableColumns;
  },
};
